import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../hooks';
import { ColaboradorService } from '../services/api/rh/colaborador/ColaboradorService';

type TAutoCompleteOption = {
  idfun: string;
  label: string;
  urlimg: string;
} 

interface IAutoCompleteFuncionariosProps {
  isExternalLoading?: boolean;
  urlfoto?: (texturlfoto: string | undefined) => void;
  uuidfun?: (novoTextoselect: string | undefined) => void;
}

export const AutoCompleteFuncionario01: React.FC<IAutoCompleteFuncionariosProps> = ({ isExternalLoading = false, urlfoto, uuidfun}) => {

  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>('');

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    setIsLoading(true);

    debounce(() => {
      ColaboradorService.getAllList(busca, selectedId)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(funcionario => ({ idfun: funcionario.idfun, label: funcionario.nome, urlimg: funcionario.urlimg })));
          }
        });
    });

  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idfun === selectedId);
    if (!selectedOption) return null;

    return selectedOption; 
  }, [selectedId, opcoes]);

  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idfun); uuidfun?.(newValue?.idfun); urlfoto?.(newValue?.urlimg); setBusca(''); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Colaborador"
        />
      )}
    />
  );
};